import { cn } from "@/lib/utils";
import { useTheme } from "@blueskydataplatform/shared-ui/theme/theme-provider";
import { CatalogFooter } from "@blueskydataplatform/shared-ui/components/footer";
import { MaintenanceBanner } from "@blueskydataplatform/shared-ui/components/maintenance-banner";
import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router";
import InitProvider from "./init-provider";

export function Layout() {
  const { theme } = useTheme();
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to the top of the page when the route changes
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <div className={cn("min-h-screen min-w-screen bg-background antialiased w-full flex flex-col", theme)}>
      <MaintenanceBanner />
      <main className={cn("flex-1 flex-col flex max-w-[100vw]")}>
        <InitProvider />
        <Outlet />
      </main>
      <CatalogFooter />
    </div>
  );
}
